import request from '@/utils/request'

// 고객관리 조회
export function getClientManage(params, isNotify) {
  return request({
    url: `/api/getClientManage`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 고객관리 저장
export function saveClientManage(params, isNotify) {
  return request({
    url: `/api/saveClientManage`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { use: isNotify, apitype: 'saved' }
  })
}
// 고객관리 상세페이지 고객정보 조회
export function getClientManageDetail(params, isNotify) {
  return request({
    url: `/api/getClientManageDetail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 고객관리 상세페이지 사업장 조회
export function getClientManageCompanyDetail(params, isNotify) {
  return request({
    url: `/api/getClientManageCompanyDetail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { use: isNotify, apitype: 'searched' }
  })
}